
import { Component, OnDestroy, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';
import { Subscription } from 'rxjs/Subscription';
import { GasContractDashboard } from '../../../models/gas-contract-dashboard.model';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { fadeInOut } from '../../../services/animations';
import { GasContractService } from '../../../services/gas-contract.service';

@Component({
    selector: 'gas-dashboard',
    template: require('./gas-dashboard.component.html'),
    styles: [require('./gas-dashboard.component.css')],
    animations: [fadeInOut]
})
export class GasDashboardComponent implements OnInit, OnDestroy {

    gasContracts: GasContractDashboard[] = [];
    selectedContracts: GasContractDashboard[] = [];
    loading: boolean = true;
    startYear: number = moment().year();
    now: Date = new Date();
    totalRecords: number = 0;
    limit = 10;
    contractTypes: string[] = ['Beide', 'Bedrijf', 'Particulier'];
    selectedContractType = 'Beide';
    private subscribers: Subscription[] = [];

    constructor(private gasContractService: GasContractService, private alertService: AlertService,
        private accountService: AccountService, private ngxLogger: NGXLogger) { }

    ngOnInit(): void {
        // this.loading = true;
        // this.gasContractService.getAllForDashboard().subscribe((res: any[]) => {
        //     this.gasContracts = res;
        //     this.loading = false;
        // }, error => {
        //     this.ngxLogger.error(error.message);
        //     throw error;
        // });
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    loadRecords(event: LazyLoadEvent) {
        let orderby = event.sortField;
        if (orderby) {
            // if (orderby === '') {
            //     orderby = '';
            // }
            if (event.sortOrder > 0) {
                orderby = '-' + orderby;
            }
        } else {
            orderby = '';
        }
        this.loading = true;
        const limit = event.rows;
        const offset = event.first;
        const searchQuery = event.globalFilter instanceof HTMLInputElement ? event.globalFilter.value : event.globalFilter;
        const getAllForDashboardLazyLoadSubscriber = this.gasContractService.getAllForDashboardLazyLoad(limit, offset, orderby, this.selectedContractType, searchQuery).subscribe(
            (records: { Item1: GasContractDashboard[], Item2: number }) => {
                if (records != null) {
                    this.gasContracts = records.Item1;
                    this.totalRecords = records.Item2;
                } else {
                    this.gasContracts = [];
                    this.totalRecords = 0;
                }
                this.loading = false;
            }, error => {
                this.loading = false;
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(getAllForDashboardLazyLoadSubscriber);
    }

    OnContractTypeChange($event, dt) {
        this.loadRecords(dt);
    }

    exportExcel() {
        if (this.gasContracts.length > 0) {
            let ids: string = "0";
            if (this.selectedContracts && this.selectedContracts.length > 0) {
                ids = this.selectedContracts.map(z => z.GasContract.Id).toString();
            } else {
                ids = this.gasContracts.map(z => z.GasContract.Id).toString();
            }
            this.alertService.showMessage('Gas Contract', 'Downloaden van bestanden is bezig!', MessageSeverity.info);
            const exportSubscriber = this.gasContractService.exportExcel(ids).subscribe(data => {
                saveAs(data, 'GasContracten.xlsx');
                this.alertService.showMessage('Gas Contract', 'Bestandsdownload voltooid!', MessageSeverity.info);
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(exportSubscriber);
        } else {
            this.alertService.showMessage('Gas Contract', 'Geen contract gevonden!', MessageSeverity.warn);
        }
    }

    lookupRowStyleClass(rowData: GasContractDashboard) {
        const now = moment();
        const end = moment(rowData.ContractEndDate);
        const diff = end.diff(now, 'months');
        return diff < 6 ? 'bg-yellow' : '';
    }

    setBackColor(x, endex, value) {

        let color: string;
        if (endex < value) {
            color = '#f56954'; // red
        } else {
            color = '#00a65a'; // green
        }
        x.parentNode.parentNode.style.color = '#ffffff';
        x.parentNode.parentNode.style.backgroundColor = color; // x.parentNode.parentNode accesses the <td> element of table :)
    }

    setTextAndBackColor(x, data: GasContractDashboard, year) {
        const cs = moment(data.ContractStartDate);
        const ce = moment(data.ContractEndDate);
        const ys = moment(new Date(year, 0, 1));
        const ye = moment(new Date(year, 11, 31));
        let text: string;
        let color: string;

        if (cs <= ys && ce >= ye || cs.year() > ys.year()) {
            text = 'G'; // green
            color = '#00a65a'; // green
        } else {
            if (ce >= ye && cs.year() == ys.year()) {
                text = 'G'; // green
                color = '#00a65a'; // green
            } else if (ce.year() == ys.year()) {
                text = "O";
                color = '#f39c12'; // orange
            } else {
                text = 'R'; // red
                color = '#f56954'; // red
            }
        }
        x.parentNode.parentNode.style.color = '#ffffff';
        x.parentNode.parentNode.style.backgroundColor = color; // x.parentNode.parentNode accesses the <td> element of table :)

        return text;
    }

    get canmanageGasDashboardPermission() {
        return this.accountService.userHasPermission(Permission.manageGasDashboardPermission);
    }

    get cangasContractEditPermission() {
        return this.accountService.userHasPermission(Permission.gasContractEditPermission);
    }

    get cangasContractViewPermission() {
        return this.accountService.userHasPermission(Permission.gasContractViewPermission);
    }

    get cangasExportPermission() {
        return this.accountService.userHasPermission(Permission.gasExportPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/gas/gas-dashboard/gas-dashboard.component.ts